import { Box, Button, Grid, Typography } from "@mui/material";
import CsvReadingResultTable from "./CsvReadingResultTable";
import CsvReadingResultTablePaging from "./CsvReadingResultTablePaging";
import CsvReadingResultRow from "./CsvReadingResultRow";
import CsvReadingResultHeaderRow from "./CsvReadingResultHeaderRow";
import ErrorMessageBox from "../../../../../components/ErrorMessageBox";

const getErrorMessages = (hasError) => {
  return hasError
    ? ["登録できない注文行があります。"]
    : []
}

const hasResultToPreserve = (results) => {
  return results.some((result) => result.enabledPreservation);
}

export default function CsvReadingResultForm (props) {


  const handleChangePage = (page) => {
    props.movePage(page);
  }

  const handleClickAddOrder = async (_) => {

    await props.onSubmitOrder();
    
  };

  const resultRows =  props.results 
    .slice(
      (props.page - 1) * props.maxRowCount,
      props.page * props.maxRowCount
    ).map((result, index) => (
        <CsvReadingResultRow
          key={`result_row_${index}`}
          result={result}
          onChangeRowValue={props.changeRowValue}
          onChangeEnabledPreservation={props.changeEnabledPreservation}
          selectOptions={props.selectOptions}
        />
      ));

  return (
    <Box>
      <Grid container my={1}>
        <Grid item>
          <Typography
            sx={{fontSize: 20, fontWeight: 'bold'}}
          >
            CSV取込結果
          </Typography>
        </Grid>
        <Grid item marginLeft='auto'>
          <Button
            variant="contained"
            disabled={props.hasError || !hasResultToPreserve(props.results)}
            onClick={handleClickAddOrder}
          >
            注文に追加
          </Button>
        </Grid>
      </Grid>
      <ErrorMessageBox
        messages={getErrorMessages(props.hasError)}
      />
      <CsvReadingResultTable
        headerRow={
          <CsvReadingResultHeaderRow />
        }
        resultRows={resultRows}        
      />
      <CsvReadingResultTablePaging
        page={props.page}
        maxPage={props.maxPage}
        onChangePage={handleChangePage}
      />
    </Box>
  );
}